import type { TImageNodeAttrs } from '../types';

type TImageReadinessAttrs = Partial<Pick<TImageNodeAttrs, 'file' | 'blobName' | 'docId'>>;

export const isImagePending = ({ file, blobName, docId }: TImageReadinessAttrs, documentId: string | null): boolean =>
  Boolean(file || (blobName && docId && docId !== documentId));
